import React, { Fragment, useState } from 'react';

// Components

import BlockWrapper from '../../../components/hyperDashboard/blocks/BlockWrapper';

// Utils

import { familyAnalyzer } from '../../../utils/householdMember/familyAnalyzer';
import { normalizeNameOfPerson } from '../../../utils/normalize/normalizeNameOfPerson';
import { getDateDifference } from '../../../utils/dates/date.utils';

// Constants

import { INLINE_ELIGIBILITY_VALUES } from '../../../constants/ssap/miscellaneous/miscellaneous';
import { OTHER_PROGRAMS_TYPES } from '../../../constants/ssap/hhmTypes/otherProgramsList';

const EscPageRenderInfo = props => {
    const {
        id,
        bloodRelationship,
        bloodRelationshipCodes,
        inlineEligibilityIgnoredForEscPage,
        inlineCurrentIncomeEnabled,
        isState,
        householdMembers,
        loadedRelations,
        primaryTaxFilerPersonId,
        serverDate
    } = props;

    const { NOT_APPLICABLE, YES } = INLINE_ELIGIBILITY_VALUES;
    const { COBRA_COVERAGE, RETIRE_HEALTH_BENEFITS, VETERANS_AFFAIRS_HCP  } = OTHER_PROGRAMS_TYPES;

    const [localState, updateState] = useState(
        householdMembers
            .reduce(
                (hhms, hhm) => {
                    return {
                        ...hhms,
                        [hhm.applicantGuid]: {
                            collapsed: false
                        }
                    };
                },
                {}
            )
    );

    const handleClick = e => {
        const { name } = e.currentTarget;
        updateState(state => ({
            ...state,
            [name]: {
                ...state[name],
                collapsed: !state[name].collapsed
            }
        }));
    };

    return (
        <BlockWrapper
            id = { id }
            additionalStyles = { { width: 500 } }
        >
            <div style = { { fontSize: '1.5rem', color: 'yellow', marginBottom: '1.5rem' } } >
                Note: If return is &quot;true&quot; - ESC Page is skipped
            </div>

            {
                householdMembers.map((hhm, hhmIndex) => {
                    const {
                        applicantGuid,
                        applyingForCoverageIndicator,
                        name,
                        inlineEligibility: {
                            preliminaryAptcCsrStatus,
                        },
                        healthCoverage: {
                            currentOtherInsurance: {
                                medicareEligibleIndicator,
                                otherStateOrFederalPrograms,
                                peaceCorpsIndicator,
                                tricareEligibleIndicator
                            }
                        },
                    } = hhm;

                    const familyConfig = {
                        bloodRelationships: bloodRelationship,
                        bloodRelationshipCodes,
                        currentMemberIndex: hhmIndex,
                        householdMembers,
                        isState,
                        loadedRelations,
                        primaryTaxFilerPersonId,
                        serverDate
                    };

                    const allStatuses = householdMembers.map((hhm, idx) => ({
                        hhmStatus: familyAnalyzer({ ...familyConfig, currentMemberIndex: idx })
                    }));

                    const age = getDateDifference(serverDate, hhm.dateOfBirth, 'year');

                    const getIfSkippedBecauseOfBasicEligibility = () => {
                        if(!hhm.applyingForCoverageIndicator) {
                            return true;
                        }
                        if(age >= 14) {
                            return false;
                        } else {
                            return !allStatuses[hhmIndex].hhmStatus.currentHhm.hasParentOrCaretakersWithEsc;
                        }
                    };

                    const shouldRender = [
                        preliminaryAptcCsrStatus === YES,
                        peaceCorpsIndicator === false,
                        tricareEligibleIndicator === false,
                        medicareEligibleIndicator === false,
                        !otherStateOrFederalPrograms.some(pr => {
                            const { eligible, type } = pr;
                            return eligible &&
                                (type === COBRA_COVERAGE || type === RETIRE_HEALTH_BENEFITS || type === VETERANS_AFFAIRS_HCP);
                        })
                    ].every(condition => condition);

                    const oldValueWithIgnoredInlineEligibility = String(!applyingForCoverageIndicator);
                    const newValueWithIgnoredInlineEligibility = String(getIfSkippedBecauseOfBasicEligibility());

                    const areValuesMatch = oldValueWithIgnoredInlineEligibility === newValueWithIgnoredInlineEligibility;

                    const oldValueWithNotIgnoredInlineEligibility = String(
                        (inlineCurrentIncomeEnabled && preliminaryAptcCsrStatus !== NOT_APPLICABLE)
                            ? !(hhm.applyingForCoverageIndicator && shouldRender)
                            : !hhm.applyingForCoverageIndicator
                    );
                    const newValueWithNotIgnoredInlineEligibility = String(
                        (inlineCurrentIncomeEnabled && preliminaryAptcCsrStatus !== NOT_APPLICABLE)
                            ? !(!getIfSkippedBecauseOfBasicEligibility() && shouldRender)
                            : getIfSkippedBecauseOfBasicEligibility()
                    );

                    const areValuesMatch2 = oldValueWithNotIgnoredInlineEligibility === newValueWithNotIgnoredInlineEligibility;

                    return (
                        <div key={applicantGuid} className='grid-container' style = { { display: 'grid', gridTemplateColumns: 'auto auto', marginBottom: '1rem' } }>
                            <div className = 'grid-item' style = { { fontSize: '1.5rem', color: 'darkred', marginBottom: '1rem' } } >
                                {normalizeNameOfPerson(name)}
                            </div>
                            <div className = 'grid-item'>
                                <button name={applicantGuid} onClick={handleClick}>
                                    <div style = { { minWidth: '2rem' } }>
                                        {localState[applicantGuid].collapsed ? ' + ' : ' - '}
                                    </div>
                                </button>
                            </div>

                            {
                                localState[applicantGuid].collapsed === false &&

                                <Fragment>
                                    <div className = 'grid-item'>
                                        inlineEligibilityIgnoredForEscPage:
                                    </div>
                                    <div className = 'grid-item'>
                                        {String(inlineEligibilityIgnoredForEscPage)}
                                    </div>

                                    <div className = 'grid-item'>
                                        inlineCurrentIncomeEnabled:
                                    </div>
                                    <div className = 'grid-item'>
                                        {String(inlineCurrentIncomeEnabled)}
                                    </div>

                                    <div className = 'grid-item' >
                                        Age / Is 14 or older:
                                    </div>
                                    <div className = 'grid-item'>
                                        {age} / <span style = { { color: age >= 14 ? 'lightgreen' : 'red' } }>{age >= 14 ? 'Yes' : 'No'}</span>
                                    </div>

                                    <div className = 'grid-item'>
                                        hasParentOrCaretakersWithEsc:
                                    </div>
                                    <div className = 'grid-item'>
                                        {String(allStatuses[hhmIndex].hhmStatus.currentHhm.hasParentOrCaretakersWithEsc)}
                                    </div>

                                    <div className = 'grid-item'>
                                        applyingForCoverageIndicator:
                                    </div>
                                    <div className = 'grid-item'>
                                        {String(applyingForCoverageIndicator)}
                                    </div>

                                    <div className = 'grid-item'>
                                        getIfSkippedBecauseOfBasicEligibility:
                                    </div>
                                    <div className = 'grid-item'>
                                        {String(getIfSkippedBecauseOfBasicEligibility())}
                                    </div>

                                    <div className = 'grid-item'>
                                        Inline eligibility used / should render:
                                    </div>
                                    <div className = 'grid-item'>
                                        {String(inlineCurrentIncomeEnabled && preliminaryAptcCsrStatus !== NOT_APPLICABLE)} / <span style = { { color: shouldRender ? 'lightgreen' : 'red' } }>{String(shouldRender)}</span>
                                    </div>

                                    <div className = 'grid-item'>
                                        Return value:
                                    </div>
                                    <div className = 'grid-item'>
                                        old&nbsp;&nbsp;&nbsp;   |||     new
                                    </div>

                                    {
                                        inlineEligibilityIgnoredForEscPage &&

                                        <Fragment>
                                            <div
                                                className = 'grid-item'
                                                style = { { color: areValuesMatch ? 'lightcyan' : 'red' } }
                                            >
                                                Inline eligibility ignored:
                                            </div>
                                            <div className = 'grid-item'>
                                                {oldValueWithIgnoredInlineEligibility}  |||   {newValueWithIgnoredInlineEligibility}
                                            </div>
                                        </Fragment>
                                    }

                                    {
                                        !inlineEligibilityIgnoredForEscPage &&

                                        <Fragment>
                                            <div
                                                className = 'grid-item'
                                                style = { { color: areValuesMatch2 ? 'lightcyan' : 'red' } }
                                            >
                                                Inline eligibility NOT ignored:
                                            </div>
                                            <div className = 'grid-item'>
                                                {oldValueWithNotIgnoredInlineEligibility}  |||   {newValueWithNotIgnoredInlineEligibility}
                                            </div>
                                        </Fragment>
                                    }
                                </Fragment>
                            }
                        </div>
                    );
                })
            }
        </BlockWrapper>
    );
};

export default EscPageRenderInfo;